export default __webpack_public_path__ + "9b6a906f200b635b704931307a71504f.jpg";